import React, { useEffect, useState } from "react";
import * as httpClient from "../../../util/httpClient";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import * as Common from "../../../store/common";
import { STEP_TWO_FACTOR_AUTHENTICATION } from "../ReCompleteRegistrationUtil";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import * as packageUpgradeDowngradeAction from "../../../store/packageUpgradeService/actions";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { isValidPhoneNo } from "../../../util/phoneNumberValidationUtil";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";

interface IProps {
    reCompleteRegistrationState?: any;
    setReCompleteRegistrationState?: any;
}

const NotificationPreference = ({ reCompleteRegistrationState, setReCompleteRegistrationState }: IProps) => {
    const { handleSubmit, errors, control, watch } = useForm({
        mode: "onTouched",
        criteriaMode: "all",
    });
    let countryValue = i18nService.get("Country");
    if (!countryValue) countryValue = "US";
    const isAvastId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2611
                ? true
                : false
            : false
    );
    const isAVGId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2659
                ? true
                : false
            : false
    );
    const isAVGTestId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2662
                ? true
                : false
            : false
    );
    const isDeviceVerificationActivated = sessionStorage.getItem('activateDeviceVerificationFlag');
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const dispatch = useDispatch();
    const [state, setState] = useState({ isChecked: true, isLoading: false });
    let history = useHistory();
    const requestPackageData = () => dispatch(packageUpgradeDowngradeAction.actionCreators.requestPackageData());

    const setPrevious = () => {
        setReCompleteRegistrationState({
            ...reCompleteRegistrationState,
            step: STEP_TWO_FACTOR_AUTHENTICATION,
        });
    };

    const onSubmit = (data: any) => {
        setState({ ...state, isLoading: true });

        const requestBody = {
            ssn: reCompleteRegistrationState.SSN,
            confirmSsn: reCompleteRegistrationState.confirmSSN,
            address1: reCompleteRegistrationState.address1,
            address2: reCompleteRegistrationState.address2,
            city: reCompleteRegistrationState.city,
            state: reCompleteRegistrationState.state,
            zip: reCompleteRegistrationState.zip,
            phone: reCompleteRegistrationState.phone,
            firstName: reCompleteRegistrationState.firstName,
            lastName: reCompleteRegistrationState.lastName,
            dob: reCompleteRegistrationState.dob,
            preferencePhone: state.isChecked ? data.SMSNumber : "",
            isTextMessageActive: state.isChecked,
        };

        httpClient
            .sendRequest("POST", "web/Registration/Re-Complete-Registration", requestBody)
            .then((data: any) => {
                if (data.isSuccess) {
                    if (isDeviceVerificationActivated === 'true') {
                        httpClient.sendRequest("PUT", "web/DeviceRisk/UpdateDeviceRiskId");
                    }                   
                    dispatch({ type: "SUBMIT_LOGIN", userInfo: data });
                    // load user services after successful login
                    dispatch(Common.actionCreators.refreshUserPermission());
                    requestPackageData();
                    history.push("/dashboard");
                } else {
                    history.push("/register/error");
                }
            })
            .catch(() => {
                history.push("/register/error");
            });

        window.addToDataLayer({ event: "Submit NotificationPreference" });
    };

    const getCountryInfo = () => {
        let currentCountry = countryValue;
        if (currentCountry.includes("US") || currentCountry.includes("CA")) {
            return false;
        } else {
            return true;
        }
    };

    const handleInputChange = () => {
        if (state.isChecked) {
            setState({ ...state, isChecked: false });
            return;
        }
        setState({ ...state, isChecked: true });
    };

    useEffect(() => {
        const elements = document.getElementsByClassName("PhoneInputCountry");

        if (elements && elements.length > 0) {
            try {
                for (const el of elements) {
                    const childs = el.children;
                    if (childs[0].nodeName === "SELECT") {
                        const selectEl = childs[0] as HTMLSelectElement;
                        selectEl.disabled = true;
                    }
                }
            } catch { }
        }
    }, []);

    return (
        <div className="row" id="content">
            <div className="col-xs">
                <div className="box box-has-shadow offset-padding">
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-icon" aria-hidden="true">
                                <RenderIcons iconName="sliders-h" />
                            </div>
                            <div className="box-title-text">
                                <h2 className="box-title">Notification Preferences</h2>
                            </div>
                        </div>
                    </div>
                    <div className={state.isLoading ? "box-content loading" : "box-content"}>
                        <form id="form-notification" onSubmit={handleSubmit(onSubmit)}>
                            <div className="row between-sm">
                                <div className="col-xs-12 col-sm-12 col-no-gutter">
                                    <p>Notifications are always delivered by email. You can also select to have alerts sent via alert message. </p>
                                    <div className="margin-bottom-l"></div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-no-gutter">
                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className={`form-row inline row}`}>
                                            <div className="form-label col-xs-12 col-sm-3 col-no-gutter">
                                                <label htmlFor="label-rounting-number">Mobile Text Alerts</label>
                                            </div>
                                            <div className="form-label col-xs-12 col-sm-5 col-no-gutter">
                                                <div className="form-row">
                                                    <div className="form-input">
                                                        <label className="form-checkbox-label" htmlFor="isChecked">
                                                            <input id="isChecked"
                                                                type="checkbox"
                                                                name="isChecked"
                                                                onChange={() => handleInputChange()}
                                                                checked={state.isChecked}
                                                            />
                                                            <span className="form-checkbox-label-text">Turn ON Mobile Text Alerts</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                {state.isChecked && (
                                    <fieldset className="form-row inline">
                                        <div className="row">
                                            <div
                                                className={`form-row row inline ${errors["SMSNumber"] && "status-error"} ${errors["SMSNumber"] && watch("SMSNumber") && !parsePhoneNumber(watch("SMSNumber")) ? "country-error" : ""
                                                    }`}
                                            >
                                                <div className="form-label col-xs-12 col-sm-3 col-no-gutter">
                                                    <label htmlFor="label-phone-number">Delivery To</label>
                                                </div>
                                                <div className="form-input col-xs-12 col-sm-5 col-no-gutter">
                                                    <Controller
                                                        name={"SMSNumber"}
                                                        control={control}
                                                        defaultValue={reCompleteRegistrationState.phone ? reCompleteRegistrationState.phone : ""}
                                                        className="inputbox"
                                                        rules={{
                                                            required: true,
                                                            validate: (value) =>
                                                                value
                                                                    ? isValidPhoneNo(
                                                                        reCompleteRegistrationState && reCompleteRegistrationState.country
                                                                            ? reCompleteRegistrationState.country
                                                                            : "US",
                                                                        value
                                                                    )
                                                                    : false,
                                                        }}
                                                        render={({ onChange, value }) => (
                                                            <PhoneInput
                                                                value={value}
                                                                onChange={onChange}
                                                                international={false}
                                                                addInternationalOption={false}
                                                                defaultCountry={reCompleteRegistrationState.country ? reCompleteRegistrationState.country : "US"}
                                                                countries={[reCompleteRegistrationState.country ? reCompleteRegistrationState.country : "US"]}
                                                                id="label-phone-number"
                                                                placeholder="Enter Mobile number"
                                                                maxLength={15}
                                                                minLength={10}
                                                            />
                                                        )}
                                                    />
                                                    {!!errors["SMSNumber"] && errors["SMSNumber"].type === "required" && (
                                                        <span className="form-error">Mobile is required</span>
                                                    )}
                                                    {!!errors["SMSNumber"] && errors["SMSNumber"].type === "validate" && (
                                                        <span className="form-error">Invalid format. Please enter a valid mobile number.</span>
                                                    )}
                                                    {!!errors["SMSNumber"] &&
                                                        errors["SMSNumber"].type === "minLength" &&
                                                        (getCountryInfo() ? (
                                                            <span className="form-error">Mobile Number must be a minimum of 7 digits in length.</span>
                                                        ) : (
                                                            <span className="form-error">Invalid format. Mobile Number must be 10 digits in length.</span>
                                                        ))}
                                                    {!!errors["SMSNumber"] &&
                                                        errors["SMSNumber"].type === "maxLength" &&
                                                        (getCountryInfo() ? (
                                                            <span className="form-error">Mobile Number must be a maximum of 15 digits in length.</span>
                                                        ) : (
                                                            <span className="form-error">Invalid format. Mobile Number must be 10 digits in length.</span>
                                                        ))}
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                )}

                                <div className="margin-bottom-xl"></div>
                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className={`form-row inline row}`}>
                                            <p>
                                                Click <span className="strong">'Done' </span> below and we will start monitoring your information immediately.
                                            </p>
                                        </div>
                                        <div className="margin-bottom-xl"></div>
                                        <div className={`form-row inline row}`}>
                                            <p className="strong">
                                                You can update or add unfinished information on your Dashboard or under{" "}
                                                {(isAvastId || isAVGId || isAVGTestId) ? "Manage Profile" : "Manage Account"}.
                                            </p>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>

                            <div className="col-xs-12 col-sm-12 col-no-gutter">
                                <div className="row between-xs">
                                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <ul className="list-inline list-reset">
                                            <li className="margin-left-s">
                                                <button type="button" className="btn-default btn-default btn-min-width" onClick={() => setPrevious()}>
                                                    <span className="btn-text">Previous</span>
                                                </button>
                                            </li>
                                            <li className="margin-left-s">
                                                <button type="submit" className="btn-default btn-primary btn-min-width">
                                                    <span className="btn-text">Done</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotificationPreference;
